import {
  Popover,
  Drawer,
  Button,
  CloseButton,
  VStack,
  HStack,
  Box,
  Text,
  Portal,
  useDisclosure,
} from '@chakra-ui/react';
import { FiHelpCircle } from 'react-icons/fi'
import type { ScoringProfile } from '../../types/analyticsMap'
import { SCORING_PROFILE_COLORS } from '../../types/analyticsMap'
import { useIsMobile } from '../../hooks/useIsMobile'

const HEADING = 'Who fills each type?'

function ProfileLegend({ profiles }: { profiles: ScoringProfile[] }) {
  return (
    <VStack align="stretch" gap={2.5}>
      {profiles.map((p) => (
        <HStack key={p.name} align="flex-start" gap={2}>
          <Box w={3} h={3} mt="3px" borderRadius="full" flexShrink={0} bg={SCORING_PROFILE_COLORS[p.name] ?? '#9CA3AF'} />
          <Box>
            <Text fontSize="sm" fontWeight="medium">{p.label}</Text>
            <Text fontSize="xs" color="gray.600">{p.plainSummary}</Text>
          </Box>
        </HStack>
      ))}
    </VStack>
  );
}

function triggerButton(onClick?: () => void) {
  return (
    <Button
      size="sm"
      variant='link'
      colorPalette="brand"
      minH="44px"
      justifyContent="flex-start"
      onClick={onClick}><FiHelpCircle />Who fills this?
          </Button>
  );
}

export function WhoFillsThisPopover({ profiles }: { profiles: ScoringProfile[] }) {
  const isMobile = useIsMobile()
  const sheet = useDisclosure()

  // Mobile: the design bible prefers bottom sheets over popovers for tap-first UIs.
  if (isMobile) {
    return (
      <>
        {triggerButton(sheet.onToggle)}
        <Drawer.Root placement='bottom' open={sheet.open} onOpenChange={e => {
          if (!e.open) {
            sheet.onClose();
          }
        }}>
          <Portal>

            <Drawer.Backdrop />
            <Drawer.Positioner>
              <Drawer.Content borderTopRadius="lg">
                <Drawer.CloseTrigger asChild><CloseButton size="sm" /></Drawer.CloseTrigger>
                <Drawer.Header fontSize="sm" fontWeight="semibold">{HEADING}</Drawer.Header>
                <Drawer.Body pb="env(safe-area-inset-bottom, 16px)">
                  <ProfileLegend profiles={profiles} />
                </Drawer.Body>
              </Drawer.Content>
            </Drawer.Positioner>

          </Portal>
        </Drawer.Root>
      </>
    );
  }

  return (
    <Popover.Root lazyMount unmountOnExit positioning={{
      placement: 'bottom-end'
    }}>
      <Popover.Trigger asChild>{triggerButton()}</Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content maxW="320px">
            <Popover.Arrow />
            <Popover.Title fontSize="sm" fontWeight="semibold">{HEADING}</Popover.Title>
            <Popover.Body>
              <ProfileLegend profiles={profiles} />
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
}
